<template>
  <div class="closable-alerts">
    <v-alert
      v-for="alert in alerts"
      :key="alert.id"
      v-model="alert.showAlert"
      border="left"
      :type="alert.type"
      dismissible
      dark
    >
      {{ alert.message }}
    </v-alert>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ClosableAlerts',
  data() {
    return {
      showAlert: false,
      message: '',
      typeAlert: 'success',
    };
  },
  computed: {
    ...mapGetters('alerts', ['alerts']),
  },
  methods: {
    // open(payload) {
    //   const { type, message } = payload;
    //   this.message = message;
    //   this.typeAlert = type;
    //   this.showAlert = true;
    // },
  },
};
</script>

<style lang="scss">
.closable-alerts {
  width: 300px;
  position: fixed;
  right: 0;
  bottom: 0;
}
</style>
